import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { postBattery } from '../Api'

export default generateApiAction({
  baseType: Types.BATTERIES.POST,
  api: postBattery,
  responseType: RESPONSETYPE.ID
})



// WEBPACK FOOTER //
// ./src/actions/batteries/PostAction.js